<template>
  <div class="f-row ctr site-item">
    <div class="f-row ctr item-column icon-info">
      <img :src="siteFavicon" v-if="siteFavicon" />
      <Icon class="icon-info-default" icon="home" v-else />
    </div>
    <div class="f-row ctr item-column url-info">
      <a :href="`http://${site.domain}`" target="_blank">{{ site.domain }}</a>
    </div>
    <button
      class="f-row ctr site-btn editor-btn is-disabled"
      type="button"
      :disabled="disabled"
      :title="title"
      @click="openEditor()"
    >
      Abrir editor
    </button>
    <button
      class="f-row ctr site-btn config-btn"
      type="button"
      @click="openSettings()"
    >
      <Icon icon="cog" />
    </button>
    <portal to="modal" v-if="modalTarget === `${$options.name}-${site.id}`">
      <SiteSettings :site="site" />
    </portal>
  </div>
</template>

<script>
import axios from "axios";
import { objectJSON } from "../../config/helpers";
import SiteSettings from "./SiteSettings";

export default {
  name: "SiteItem",
  components: {
    SiteSettings,
  },
  props: {
    site: Object,
  },
  computed: {
    modalTarget() {
      return this.$store.state.modal.target;
    },
    siteFavicon() {
      return objectJSON(this.site.scope)?.company.brand.favicon;
    },
    disabled() {
      return objectJSON(this.site.scope)?.company.id !== this.$store.state.context?.workspace?.id
    },
    title() {
      return this.disabled ? 'O site não está vinculado ao workspace atual' : ''
    }
  },
  methods: {
    async openEditor() {
      try {
        const scope = objectJSON(this.site.scope);
        const isAdmin = this.$store.state.context.settings?.isAdmin;
        const token = this.$store.state.auth.token;

        if (
          scope.company.id === null &&
          scope.company.context === null &&
          !isAdmin
        ) {
          const getSysResponse = await axios({
            url: `${process.env.VUE_APP_SITE_API_URL}/api/setup/crm?context=agil`,
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          const { crms } = getSysResponse.data;

          if (crms?.length === 1) {
            await axios({
              url: `${process.env.VUE_APP_SITE_API_URL}/api/setup/crm`,
              method: "PUT",
              headers: {
                Authorization: `Bearer ${token}`,
              },
              data: {
                context: crms[0].context,
                contextId: crms[0].contextId,
                domain: this.site.domain,
              },
            });
          } else {
            return this.openSettings();
          }
        }

        this.$store.commit("CHANGE_SANDBOX", { actual: this.site.id });
        this.$router.push({ name: "sandbox" }).catch(() => {});
      } catch (err) {
        console.warn(err);
      }
    },
    openSettings() {
      this.$store.commit("TOGGLE_DISPLAY_MODAL", {
        display: true,
        target: `${this.$options.name}-${this.site.id}`,
      });
    },
  }
};
</script>

<style scoped>
.site-item {
  padding: 2px;
}

.item-column {
  height: 38px;
  padding: 0 5px;
  margin: 0 2px;
  border: 1px solid #ddd;
  border-radius: 0.25rem;
  font-weight: 600;
  font-size: 14px;
}

.icon-info {
  min-width: 36px;
}

.icon-info-default {
  font-size: 16px;
}

.url-info {
  flex-grow: 1;
  min-width: 200px;
}

.url-info > a:hover {
  color: #159ad1;
}

.site-btn {
  height: 40px;
  padding: 0 15px;
  margin: 0 2px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border-radius: 0.25rem;
  /* box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2); */
  color: rgb(39, 39, 39);
  background: #d8d8d8;
}

.editor-btn {
  color: #ffffff;
  background: #159ad1;
}

.editor-btn:disabled,
editor-btn[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.config-btn {
  font-size: 16px;
  color: #ffffff;
  background: #0c6991;
}
</style>